(() => {
function mount() {
document.querySelectorAll('[data-arm-gallery]').forEach(gallery => {
if (gallery.dataset.galleryReady) return;
const main = gallery.querySelector('[data-arm-gallery-main]');
const buttons = [...gallery.querySelectorAll('[data-arm-gallery-thumb]')];
if (!main || !buttons.length) return;
gallery.dataset.galleryReady = 'true';
buttons.forEach(button => button.addEventListener('click', () => {
if (!button.dataset.full) return;
main.removeAttribute('srcset');
main.removeAttribute('sizes');
main.src = button.dataset.full;
main.alt = button.dataset.alt || '';
buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
}));
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
else mount();
document.addEventListener('shopify:section:load', mount);
})();